export default "/packs/images/footer~b0b9dd8a84d67db5ebbf96bd6631a60c.svg";